import React, { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { OnboardingBannerLayout } from '../../Components/OnboardingBannerLayout'
import { Button } from '../../../../../components/Button/Button'
import { IntegrationCategory } from '../../../../../common/integrations'
import { useTracking } from '../../../../../apps/professional-app/fa/common/tracking/hooks'
import { GrowthTrackEvent } from '../../../../../apps/professional-app/fa/common/tracking'
import { EMAIL_BANNER_COPIES } from '../../../copies/onboardingCopies'

interface EmailOnboardingBannerProps {
  onDismiss?: () => void
}

export const EmailOnboardingBanner: FC<EmailOnboardingBannerProps> = ({ onDismiss }) => {
  const navigate = useNavigate()
  const { trackingClient } = useTracking()

  const onConnectClick = () => {
    trackingClient.track({ eventName: GrowthTrackEvent.UPCOMING_EMAIL_BANNER_INTEGRATION_CLICKED })
    navigate(`/account/integration-settings#${IntegrationCategory.MAIL}`)
  }

  return (
    <OnboardingBannerLayout title={EMAIL_BANNER_COPIES.title} subtitle={EMAIL_BANNER_COPIES.subtitle} onDismiss={onDismiss}>
      <Button variant='grayButton' aria-label='Connect in Integrations' onClick={onConnectClick}>
        <span className={'fw-bold small text-truncate mw-100'}>Connect in Integrations</span>
      </Button>
    </OnboardingBannerLayout>
  )
}
